<template>
  <div class="search-container">
    <el-form ref="form" inline>
      <el-form-item label="审核状态" label-width="80px">
        <el-radio v-model="queryParam.status">全部</el-radio>
        <el-radio v-model="queryParam.status" :label="false">未审核</el-radio>
        <el-radio v-model="queryParam.status" :label="true">已审核</el-radio>
      </el-form-item>
      <el-form-item label-width="0">
        <el-button type="primary" @click="list(1)">
          <el-icon><search /></el-icon>查询
        </el-button>
      </el-form-item>
    </el-form>
  </div>
  <div class="table-container">
    <div class="table-header">
      <el-row :gutter="10">
        <el-col :span="10">
          <div class="table-title"><span></span>申请列表</div>
        </el-col>
        <el-col :span="14">
          <div class="table-button-container">
          </div>
        </el-col>
      </el-row>
    </div>
    <el-table :data="agents" border>
      <el-table-column prop="companyName" label="公司名称"></el-table-column>
      <el-table-column prop="name" label="姓名"></el-table-column>
      <el-table-column prop="phone" label="手机号"></el-table-column>
      <el-table-column label="公司地址">
        <template #default="scope">
          {{scope.row.provinceName + (scope.row.cityName !== scope.row.provinceName ? scope.row.cityName : '') + scope.row.countyName}}{{scope.row.address}}
        </template>
      </el-table-column>
      <el-table-column prop="manageRegion" label="管辖区域"></el-table-column>
      <el-table-column prop="regionManagerName" label="大区经理"></el-table-column>
      <el-table-column label="操作">
        <template #default="scope">
          <el-link type="primary" href="javascript:;" :disabled="scope.row.status" @click="showAudit(scope.row)">通过</el-link>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination @current-change="handleCurrentChange" v-model:current-page="pageIndex" @size-change="handleSizeChange"
                   :page-size="pageSize" :total="total" :page-sizes="pageSizes" :pager-count="5"
                   background
                   layout="sizes, prev, pager, next, total"></el-pagination>
  </div>

  <el-dialog title="审核确认" v-model="auditVisible" custom-class="dialog_width_small" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="auditParam" ref="auditParam">
      <el-form-item label="大区经理" label-width="78px">
        <el-select v-model="auditParam.regionManagerSn" placeholder="请选择大区经理">
          <el-option v-for="rm in regionManagers" :key="rm.sn" :label="rm.name" :value="rm.sn"></el-option>
        </el-select>
        <div class="tips"><i>注：关联佣金发放，请正确选择</i></div>
      </el-form-item>
      <el-button type="primary" @click="audit">确定</el-button>
    </el-form>
  </el-dialog>
</template>

<script>
export default {
  name: "服务商审核",
  props: {
    currentUser: {
      type: Object
    }
  },
  data() {
    return {
      pageSizes: [10, 20, 50],
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      queryParam: {
        type: 1
      },
      agents: [],
      auditVisible: false,
      auditParam: {},
      regionManagers: []
    }
  },
  methods: {
    list(pageIndex) {
      if (pageIndex) {
        this.pageIndex = pageIndex
      }
      this.$utils.deleteEmptyProperty(this.queryParam)
      this.$apis.audit.list(this.pageIndex - 1, this.pageSize, this.queryParam).then(response => {
        this.agents = response.data.data
        this.total = response.data.total
      })
    },
    handleCurrentChange(pageIndex) {
      this.pageIndex = pageIndex
      this.list()
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize
      this.list(1)
    },
    showAudit(agent) {
      this.auditVisible = true
      this.auditParam = {
        userApplySn: agent.sn,
        regionManagerSn: agent.regionManagerSn
      }
    },
    audit() {
      if (!this.auditParam.regionManagerSn) {
        this.$message.error('请选择大区经理')
        return
      }
      this.$apis.audit.audit(this.auditParam).then(response => {
        if (response.status === 200) {
          this.auditVisible = false
          this.$message({
            message: '审核成功',
            type: 'success'
          })
          this.list()
        }
      })
    }
  },
  created() {
    this.list()
    this.$apis.common.userList(0, 99, {type: 3}).then(response => {
      this.regionManagers = response.data.data
    })
  }
}
</script>

<style scoped>

</style>